import * as v from "valibot";
import { baseVals, defineValidation, validations } from "../../common/validation.common";
import { TimeZoneEnum } from "../../data/enums";

export namespace AssociateSettingsValidation {
    export const Update = defineValidation(
        v.object({
            csPhone: v.exactOptional(baseVals.phone()),
            billingDay: v.exactOptional(baseVals.intRange(1, 28, "Tanggal Tagihan Sistem")),
            billingGap: v.exactOptional(baseVals.intRange(7, 30, "Jumlah Hari Sebelum Generate Tagihan")),
            deactivateGap: v.exactOptional(baseVals.intRange(1, 15, "Tambahan Hari Toleransi Pembayaran")),
            refcode: v.exactOptional(baseVals.string()),
            marketingPoint: v.exactOptional(baseVals.intMin(0)),
            surveyPoint: v.exactOptional(baseVals.intMin(0)),
            installationPoint: v.exactOptional(baseVals.intMin(0)),
            timeZone: v.exactOptional(v.picklist(TimeZoneEnum.values)),
            startPresence: v.exactOptional(
                v.object({
                    hour: baseVals.intRange(0, 23, "Jam Waktu Mulai Absensi"),
                    minute: baseVals.intRange(0, 59, "Menit Waktu Mulai Absensi"),
                }),
            ),
            endPresence: v.exactOptional(
                v.object({
                    hour: baseVals.intRange(0, 23, "Jam Waktu Akhir Absensi"),
                    minute: baseVals.intRange(0, 59, "Menit Waktu Akhir Absensi"),
                }),
            ),
            radiusDefaultUsername: v.exactOptional(baseVals.string()),
            radiusDefaultPassword: v.exactOptional(baseVals.string()),
            dropRadius: v.exactOptional(v.boolean()),
        }),
    );

    export const Remove = defineValidation(
        v.object({
            radiusDefaultUsername: validations.deletable,
            radiusDefaultPassword: validations.deletable,
        }),
    );
}
